import { HistoryType } from 'types/withRouter';
import { RouterActionType } from './router.actionCreators';
import { STORE_ROUTER_HISTORY } from './router.actionTypes';

export type RouterStateType = {
	history: HistoryType | null;
};

export type RootStateType = {
	router: RouterStateType;
};

export const initialState: RouterStateType = {
	history: null,
};

export default (state: RouterStateType = initialState, action: RouterActionType) => {
	switch (action.type) {
		case STORE_ROUTER_HISTORY:
			return {
				...state,
				history: action.history,
			};
		default:
			return state;
	}
};
